import _get from 'lodash/get';

import { i18n } from '@shared/i18n';

import { GenericModel } from '@shared/model/generic-model';

import IdField from '@shared/fields/id-field';
import DateTimeField from '@shared/fields/date-time-field';
import StringField from '@shared/fields/string-field';
import BooleanField from '@shared/fields/boolean-field';
import EnumeratorField from '@shared/fields/enumerator-field';

import getSharedEnumeratorField from '@shared/fields/helpers/getSharedEnumeratorField';

function label(name) {
  return i18n(`entities.stripeExternalAccount.fields.${name}`);
}

const fields = (config = {}) => ({
  id: new IdField('id', label('id')),
  country: new EnumeratorField('country', label('country'), getSharedEnumeratorField('country'), { required: true }),
  currency: new EnumeratorField('currency', label('currency'), getSharedEnumeratorField('currency'), { required: true }),
  holderName: new StringField('holderName', label('holderName'), { required: true }),
  holderType: new EnumeratorField('holderType', label('holderType'), getSharedEnumeratorField('businessType'), { required: true }),
  sortCode: new StringField('sortCode', label('sortCode'), {
    required: true,
    exactLength: _get(config, 'sortCode.length', null),
    mask: _get(config, 'sortCode.mask', null),
    numeric: _get(config, 'sortCode.numeric', false),
  }),
  transitNumber: new StringField('transitNumber', label('transitNumber'), {
    required: true,
    exactLength: _get(config, 'transitNumber.length', null),
    mask: _get(config, 'transitNumber.mask', null),
    numeric: _get(config, 'transitNumber.numeric', false),
  }),
  institutionNumber: new StringField('institutionNumber', label('institutionNumber'), {
    required: true,
    exactLength: _get(config, 'institutionNumber.length', null),
    mask: _get(config, 'ibanNumber.mask', null),
    numeric: _get(config, 'ibanNumber.numeric', false),
  }),
  routingNumber: new StringField('routingNumber', label('routingNumber'), {
    required: true,
    exactLength: _get(config, 'routingNumber.length', null),
    mask: _get(config, 'routingNumber.mask', null),
    numeric: _get(config, 'routingNumber.numeric', false),
  }),
  accountNumber: new StringField('accountNumber', label('accountNumber'), {
    required: true,
    exactLength: _get(config, 'accountNumber.length', null),
    mask: _get(config, 'accountNumber.mask', null),
    numeric: _get(config, 'accountNumber.numeric', false),
  }),
  ibanNumber: new StringField('ibanNumber', label('ibanNumber'), {
    required: true,
    exactLength: _get(config, 'ibanNumber.length', null),
    mask: _get(config, 'ibanNumber.mask', null),
    numeric: _get(config, 'ibanNumber.numeric', false),
  }),
  status: new EnumeratorField('status', label('status'), getSharedEnumeratorField('externalAccountStatus')),
  defaultForCurrency: new BooleanField('defaultForCurrency', label('defaultForCurrency'),),
  createdAt: new DateTimeField('createdAt', label('createdAt')),
  updatedAt: new DateTimeField('updatedAt', label('updatedAt')),
});

export class StripeExternalAccountModel extends GenericModel {
  static fields(config) {
    return fields(config);
  }

  static presenter(row, fieldName, config) {
    const fields = this.fields(config);

    if (!fields[fieldName]) {
      throw new Error(`${fieldName} not found`);
    }

    return fields[fieldName].forPresenter(row[fields[fieldName].name]);
  }
}
